import { useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight, Instagram, Film, BarChart3, Code2, Palette, FileText, Crown, Plus } from "lucide-react";

const SECTIONS = [
  {
    no: "01",
    icon: Instagram,
    title: "Comprehensive Social Media Management",
    intro: "End-to-end ownership of your social presence — from strategy to execution.",
    items: ["Monthly content calendar", "Static posts & carousels", "Reels & short-form video", "Captions & hashtag strategy", "Community engagement", "Monthly reporting"],
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBtaW5pbWFsJTIwZGF0YSUyMGRhc2hib2FyZCUyMGFuYWx5dGljcyUyMGRhcmt8ZW58MHx8fHwxNzgwODU2MTg2fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    no: "02", icon: Film,
    title: "Reels & Creative Production",
    intro: "Scroll-stopping short-form video crafted for the algorithm and the audience.",
    items: ["Concept & storyboarding", "Filming & production", "Editing & motion graphics", "Trending audio research", "Platform-native formats", "Hook-led scripting"],
    image: "https://images.unsplash.com/photo-1642945538257-d1e69abfb085?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwzfHxhYnN0cmFjdCUyMGx1eHVyeSUyMGRhcmslMjBnb2xkJTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc4MDg1NjE4Nnww&ixlib=rb-4.1.0&q=85",
  },
  {
    no: "03", icon: BarChart3,
    title: "Performance Marketing",
    intro: "Acquisition engines built on data, creative velocity and disciplined measurement.",
    items: ["Meta Ads (Facebook & Instagram)", "Google Ads (Search, Display, YouTube)", "Retargeting campaigns", "Conversion tracking & GTM", "Audience research & testing", "Weekly optimization"],
    image: "https://images.unsplash.com/photo-1761437855740-c894da924d79?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHw0fHxhYnN0cmFjdCUyMGdlb21ldHJpYyUyMGdvbGQlMjB0ZXh0dXJlJTIwZGFya3xlbnwwfHx8fDE3ODA4NTYxODZ8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    no: "04", icon: Code2,
    title: "Website Design & Development",
    intro: "Premium digital experiences engineered for conversion and brand authority.",
    items: ["Corporate websites", "Landing pages", "WordPress development", "Mobile-first responsive design", "Website audits & strategy", "Conversion optimization"],
    image: "https://images.unsplash.com/photo-1698500278205-bf650c97a1f3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwxfHxhYnN0cmFjdCUyMGdlb21ldHJpYyUyMGdvbGQlMjB0ZXh0dXJlJTIwZGFya3xlbnwwfHx8fDE3ODA4NTYxODZ8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    no: "05", icon: Palette,
    title: "Branding & Identity",
    intro: "Identity systems and visual languages that build distinction over time.",
    items: ["Logo design", "Brand kit & guidelines", "Visual identity systems", "Brand positioning", "Tone of voice", "Brand audits"],
    image: "https://images.unsplash.com/photo-1642945538257-d1e69abfb085?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwzfHxhYnN0cmFjdCUyMGx1eHVyeSUyMGRhcmslMjBnb2xkJTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc4MDg1NjE4Nnww&ixlib=rb-4.1.0&q=85",
  },
  {
    no: "06", icon: FileText,
    title: "Copywriting & Content",
    intro: "Words that earn attention — and conversions.",
    items: ["Website copy", "SEO blog writing", "Social captions", "Ad copywriting", "Email sequences", "Long-form thought leadership"],
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBtaW5pbWFsJTIwZGF0YSUyMGRhc2hib2FyZCUyMGFuYWx5dGljcyUyMGRhcmt8ZW58MHx8fHwxNzgwODU2MTg2fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    no: "07", icon: Crown,
    title: "Marketing Consulting",
    intro: "CXO-level strategy and embedded marketing leadership for ambitious teams.",
    items: ["CXO marketing strategy", "GTM sprint programs", "Marketing funnels", "Content roadmaps", "Performance reviews", "Sales enablement inputs"],
    image: "https://images.unsplash.com/photo-1761437855740-c894da924d79?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHw0fHxhYnN0cmFjdCUyMGdlb21ldHJpYyUyMGdvbGQlMjB0ZXh0dXJlJTIwZGFya3xlbnwwfHx8fDE3ODA4NTYxODZ8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    no: "08", icon: Plus,
    title: "Add-On Services",
    intro: "Specialised services to complement any engagement.",
    items: ["Influencer shortlisting", "ORM & reputation management", "Chatbot setup", "Competitor audits", "Marketing automation", "Quarterly brand refresh"],
    image: "https://images.unsplash.com/photo-1698500278205-bf650c97a1f3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwxfHxhYnN0cmFjdCUyMGdlb21ldHJpYyUyMGdvbGQlMjB0ZXh0dXJlJTIwZGFya3xlbnwwfHx8fDE3ODA4NTYxODZ8MA&ixlib=rb-4.1.0&q=85",
  },
];

export default function Services() {
  useEffect(() => { document.title = "Services — The Indian Marketing"; }, []);

  return (
    <div data-testid="services-page" className="bg-[#2E2E31] text-white">
      <section className="pt-40 pb-20 md:pt-48 md:pb-28 relative overflow-hidden">
        <div className="absolute inset-0 grid-pattern opacity-30" />
        <div className="relative max-w-7xl mx-auto px-6 md:px-10">
          <div className="flex items-center gap-3 mb-8">
            <span className="h-px w-10 bg-[#D4AF37]" />
            <span className="font-outfit text-xs uppercase tracking-[0.3em] text-[#D4AF37]">Our Capabilities</span>
          </div>
          <h1 className="font-playfair text-5xl md:text-6xl lg:text-7xl text-white tracking-tight leading-[1.05] max-w-5xl">
            A full studio for <em className="text-[#D4AF37] font-normal">content</em>, <em className="text-[#D4AF37] font-normal">campaigns</em> and <em className="text-[#D4AF37] font-normal">brand craft</em>.
          </h1>
          <p className="font-outfit text-lg md:text-xl text-[#D9D9D9] mt-10 max-w-3xl leading-relaxed">
            Eight integrated practices, designed to work independently or together. Engage us for a single sprint, a quarterly retainer or as your fractional leadership team.
          </p>
        </div>
      </section>

      {SECTIONS.map((s, i) => {
        const Icon = s.icon;
        const reverse = i % 2 === 1;
        return (
          <section
            key={s.no}
            data-testid={`service-section-${s.no}`}
            className={`py-20 md:py-28 ${i % 2 === 1 ? "bg-[#111111]" : ""}`}
          >
            <div className="max-w-7xl mx-auto px-6 md:px-10">
              <motion.div
                initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }} transition={{ duration: 0.8 }}
                className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center"
              >
                <div className={`lg:col-span-5 ${reverse ? "lg:order-2" : ""}`}>
                  <div className="aspect-[4/5] overflow-hidden relative zoom-on-hover">
                    <img src={s.image} alt={s.title} className="w-full h-full object-cover" />
                    <div className="absolute inset-0 bg-gradient-to-t from-[#111111]/60 to-transparent" />
                    <div className="absolute top-6 left-6 font-playfair text-7xl text-[#D4AF37]/80 leading-none">{s.no}</div>
                  </div>
                </div>

                <div className={`lg:col-span-7 ${reverse ? "lg:order-1 lg:pr-12" : "lg:pl-8"}`}>
                  <div className="flex items-center gap-4 mb-6">
                    <Icon size={28} strokeWidth={1.25} className="text-[#D4AF37]" />
                    <span className="font-outfit text-xs uppercase tracking-[0.3em] text-[#D4AF37]">Section {s.no}</span>
                  </div>
                  <h2 className="font-playfair text-3xl md:text-5xl text-white tracking-tight leading-[1.1]">{s.title}</h2>
                  <p className="font-outfit text-lg text-[#D9D9D9] mt-6 leading-relaxed">{s.intro}</p>

                  <ul className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-1">
                    {s.items.map((it, idx) => (
                      <li key={idx} className="border-b border-white/10 py-3 flex items-center gap-3">
                        <span className="text-[#D4AF37] text-xs">◆</span>
                        <span className="font-outfit text-sm text-[#D9D9D9]">{it}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </motion.div>
            </div>
          </section>
        );
      })}

      <section className="py-24 md:py-32">
        <div className="max-w-5xl mx-auto px-6 md:px-10 text-center">
          <h2 className="font-playfair text-4xl md:text-5xl text-white tracking-tight leading-tight">
            Not sure where to start?
          </h2>
          <p className="font-outfit text-lg text-[#D9D9D9] mt-6 max-w-2xl mx-auto">
            A 30-minute conversation is the fastest way to scope the right engagement for your brand stage and growth ambition.
          </p>
          <Link
            to="/contact"
            data-testid="services-cta-contact"
            className="inline-flex items-center gap-3 mt-10 bg-[#D4AF37] text-black font-outfit font-medium px-10 py-5 uppercase tracking-[0.2em] text-sm hover:bg-[#F0C84B] transition-colors"
          >
            Start a Conversation <ArrowUpRight size={16} />
          </Link>
        </div>
      </section>
    </div>
  );
}
